"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTestId;
var _react = require("react");
var _contexts = require("../contexts");
var _isTestEnv = require("../internals/isTestEnv");
/**
 * @typedef { Object } TestIdFunctions
 * @property { generateTestId~generateTestIdFunction } getTestId - Returns testid value
 * @property { generateTestIdProps~generateTestIdObjectFunction } getTestIdProps - Returns testid object
 */

/**
 * Use test id hook that helps you generate test id
 *
 * @example <caption>Usage of get test id</caption>
 * function Component() {
 *   const { getTestId } = useTestId();
 *
 *   return (<button data-testid={getTestId('my-button')}>Test</button>)
 * }
 * @example <caption>Usage of get test id props</caption>
 * function Component() {
 *   const { getTestIdProps } = useTestId();
 *
 *   return (<button {...getTestIdProps('my-button')}>Test</button>)
 * }
 * @throws { Error } Error when testIdContext isn't defined
 * @returns { TestIdFunctions } utils for test id
 */
function useTestId() {
  const context = (0, _react.useContext)(_contexts.testIdContext);
  if ((0, _isTestEnv.isTestEnv)()) {
    // Currently false positive.
    return {
      getTestId: name => name,
      getTestIdProps: name => ({
        'data-testid': name
      })
    };
  }
  if (!context) {
    throw new Error("TestIdContext isn't defined. Please add `<TestIdProvider />` to your Application.");
  }
  return context;
}
//# sourceMappingURL=useTestId.js.map